import UseDisableRightClick from "../../hook/use-disable-right-click";
import DB from "../../utils/db.json";
import MetaTagsSEO from "../../utils/metaTagsFunction";
import LibraryBanner from "./components/libraryBanner";
import LibraryWrapper from "./components/libraryWrapper";

function Library() {
  UseDisableRightClick();

  return (
    <>
      <MetaTagsSEO metaTags={DB.galleryMetaTags} title="Gallery - JBGlass" />

      <LibraryBanner />

      <LibraryWrapper />
    </>
  );
}

export default Library;
